import { render, staticRenderFns } from "./ResourceScroller.MovieBox.vue?vue&type=template&id=3a5f4824&scoped=true&"
import script from "./ResourceScroller.MovieBox.vue?vue&type=script&lang=js&"
export * from "./ResourceScroller.MovieBox.vue?vue&type=script&lang=js&"
import style0 from "./ResourceScroller.MovieBox.vue?vue&type=style&index=0&id=3a5f4824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f4824",
  null
  
)

component.options.__file = "ResourceScroller.MovieBox.vue"
export default component.exports